import { ReactNode, useEffect, useState } from 'react'
import theme from 'stories/utils/theme'
import styled, { css } from 'styled-components'

const StyledFlipCard = styled.div<{ align: 'left' | 'right'; isCardFlipped: boolean; isDarkTheme?: boolean }>`
    justify-self: ${({ align }) => (align === 'left' ? 'flex-start' : 'flex-end')};
    display: grid;
    height: 348px;
    width: 500px;
    position: relative;
    perspective: 1000px;

    cursor: pointer;
    .flip-card-inner {
        border-radius: ${theme.borderRadius.normal};
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        transition: transform 0.8s;

        border: 1px solid ${({ isDarkTheme }) => (isDarkTheme ? '#555268' : theme.colors.white)};
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }
    ${({ isCardFlipped }) =>
        isCardFlipped
            ? css`
                  @media (min-width: 901px) {
                      .flip-card-inner {
                          transform: rotateY(180deg);
                      }
                  }
              `
            : ''}
    .flip-card-front,
    .flip-card-back {
        box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 8px;
        .content {
            padding: 20px;
            animation: showCard 1s 1 ease-in-out forwards;
            @keyframes showCard {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }
        }
        border-radius: 13px;
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .flip-card-front {
        background-color: ${({ isDarkTheme }) => (isDarkTheme ? '#555268' : theme.colors.white)} !important;
        transform: rotateY(180deg);
    }

    /* Style the back side */
    .flip-card-back {
        background-color: ${({ isDarkTheme }) => (isDarkTheme ? '#555268' : theme.colors.white)};
        @media (max-width: 900px) {
            width: 100%;
            height: 275px;
            ${({ isCardFlipped }) =>
                isCardFlipped
                    ? css`
                          .answer {
                              display: none;
                          }
                      `
                    : css`
                          .question {
                              display: none;
                          }
                      `}
        }
    }
    @media (max-width: 1080px) {
        justify-self: center;
    }

    @media (max-width: 900px) {
        width: 100%;
        height: 275px;
    }
`

interface Props {
    children: ReactNode
    align: 'left' | 'right'
    resetCondition: boolean | string | number
    isDarkTheme?: boolean
}

export const FlipCard = ({ children, align, resetCondition, isDarkTheme }: Props) => {
    const [isCardFlipped, setIsCardFlipped] = useState(false)

    const toggleCard = () => setIsCardFlipped((value) => !value)

    useEffect(() => {
        setIsCardFlipped(false)
    }, [resetCondition])

    return (
        <StyledFlipCard align={align} onClick={toggleCard} isCardFlipped={isCardFlipped} isDarkTheme={isDarkTheme}>
            {children}
        </StyledFlipCard>
    )
}
